import { useRef } from 'react';
import { Button, Card, CardContent, CardHeader } from '@billda/design-system';
import { UserLabourGroupAssignment } from '../../UserLabourGroupAssignment';

interface UserLabourGroupCardProps {
  userId: string;
  currentGroupId: number | null | undefined;
  currentGroupName: string | null;
  isEditing: boolean;
  onEditingChange: (editing: boolean) => void;
}

export function UserLabourGroupCard({
  userId,
  currentGroupId,
  currentGroupName,
  isEditing,
  onEditingChange,
}: UserLabourGroupCardProps) {
  const editButtonRef = useRef<HTMLButtonElement>(null);

  return (
    <Card data-testid="user-labour-group-card">
      <CardHeader>
        <h3 className="type-h6">Labour Group</h3>
        {!isEditing && (
          <Button
            ref={editButtonRef}
            variant="ghost"
            size="sm"
            onClick={() => onEditingChange(true)}
            data-testid="labour-group-edit-button"
          >
            Edit
          </Button>
        )}
      </CardHeader>
      <CardContent className="pt-4">
        <div className="flex flex-col gap-4">
          <p className="type-body-md text-content-secondary">
            This group controls what labour items this user can see. Without a
            labour group, they cannot view any labour information.
          </p>

          <UserLabourGroupAssignment
            userId={userId}
            currentGroupId={currentGroupId}
            currentGroupName={currentGroupName}
            isEditing={isEditing}
            onEditingChange={onEditingChange}
            onEditingComplete={() =>
              requestAnimationFrame(() => editButtonRef.current?.focus())
            }
          />
        </div>
      </CardContent>
    </Card>
  );
}
